// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  display: grid;
  grid-template-rows: 80px auto 1fr auto;
  height: 100%;
}
.page-container .caption-container {
  text-align: left;
  padding: 10px;
  margin: auto;
}
.page-container .caption-container p {
  font-size: 0.9em;
  font-weight: bold;
  margin: 5px 0;
}
.page-container .department-selection-container {
  display: flex;
  flex-flow: column;
  padding: 0 10px;
}
.page-container .department-description-container {
  margin-top: 0;
  padding: 0 10px;
}
.page-container .department-description-container p {
  margin: 3px;
  font-size: 0.9em;
  color: #676767;
}
.page-container .department-description-container p.title {
  padding-top: 10px;
  font-weight: bold;
  font-size: 0.9em;
  color: #333;
}
.page-container .department-description-container.department-error p {
  color: red;
}
.page-container .bottom-toolbar {
  margin-top: auto;
  padding: 20px;
  box-sizing: border-box;
}
.page-container .bottom-toolbar .mat-mdc-raised-button {
  border-radius: 0;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/request-department/request-department.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sCAAA;EACA,YAAA;AACJ;AAAI;EACI,gBAAA;EACA,aAAA;EACA,YAAA;AAER;AADQ;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;AAGZ;AAAI;EACI,aAAA;EACA,iBAAA;EACA,eAAA;AAER;AAAI;EACI,aAAA;EACA,eAAA;AAER;AADQ;EACI,WAAA;EACA,gBAAA;EACA,cAAA;AAGZ;AAFY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAIhB;AADQ;EACI,UAAA;AAGZ;AAAI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAER;AADQ;EACI,gBAAA;EACA,WAAA;AAGZ","sourcesContent":[".page-container {\n    display: grid;\n    grid-template-rows: 80px auto 1fr auto;\n    height: 100%;\n    .caption-container {\n        text-align: left;\n        padding: 10px;\n        margin: auto;\n        p {\n            font-size: 0.9em;\n            font-weight: bold;\n            margin: 5px 0;\n        }\n    }\n    .department-selection-container {\n        display: flex;\n        flex-flow: column;\n        padding: 0 10px;\n    }\n    .department-description-container {\n        margin-top: 0;\n        padding: 0 10px;\n        p {\n            margin: 3px;\n            font-size: 0.9em;\n            color: #676767;\n            &.title {\n                padding-top: 10px;\n                font-weight: bold;\n                font-size: 0.9em;\n                color: #333;\n            }\n        }\n        &.department-error p {\n            color: red;\n        }\n    }\n    .bottom-toolbar {\n        margin-top: auto;\n        padding: 20px;\n        box-sizing: border-box;\n        .mat-mdc-raised-button {\n            border-radius: 0;\n            width: 100%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
